export enum StructureType {
  CONVENIO_57_95_VERSAO_31_99_ALTERACOES_ATE_30_02 = 'CONVENIO_57_95_VERSAO_31_99_ALTERACOES_ATE_30_02',
  CONVENIO_57_95_VERSAO_69_02_ALTERACOES_ICMS_142_02 = 'CONVENIO_57_95_VERSAO_69_02_ALTERACOES_ICMS_142_02',
  CONVENIO_57_95_ALTERACOES_ICMS_76_03 = 'CONVENIO_57_95_ALTERACOES_ICMS_76_03',
}

export enum NatureType {
  INTERSTATE_ONLY_SUBSTITUTION_TAX = 'INTERSTATE_ONLY_SUBSTITUTION_TAX',
  INTERSTATE_WITH_OR_WITHOUT_SUBSTITUTION_TAX = 'INTERSTATE_WITH_OR_WITHOUT_SUBSTITUTION_TAX',
  ALL_OPERATIONS_OF_INFORMER = 'ALL_OPERATIONS_OF_INFORMER',
}

export enum InventorySelectionMode {
  CURRENT_STOCK = 'CURRENT_STOCK',
  SPECIFIC_INVENTORY = 'SPECIFIC_INVENTORY',
}

export enum invoiceTypeSintegra {
  NFE = 'NFE',
  NFS = 'NFS',
  ALL = 'ALL',
}

export interface CompanySintegraDTO {
  id?: number;
  companyId?: number;
  generateRecord51?: boolean;
  generateRecord53?: boolean;
  responsibleName?: string;
  responsibleContactPhone?: string;
  sintegraStructureCode?: StructureType;
  sintegraNatureCode?: NatureType;
}

export type CompanySintegraFormValues = CompanySintegraDTO;

export interface CompanySintegraGenerate {
  companyId: number;
  startDate: string;
  endDate: string;
  invoiceType: invoiceTypeSintegra[];
  filterByReleaseDate: boolean;
  generateRecord74: boolean;
  generateRecord61R: boolean;
  filePurpose: string;
  removePartStereotypes: boolean;
  removeConsumableStereotypes: boolean;
  inventorySelectionMode: InventorySelectionMode;
  inventoryId: number;
  inventoryDate: string;
  completeWithExempt: boolean;
}

export interface CompanySintegraGenerateFormValues
  extends Omit<CompanySintegraGenerate, 'invoiceType'> {
  invoiceType: invoiceTypeSintegra;
}
